import { useEvent } from '~features/events/hooks/useEvent';

const Events = {
  AccountReactivationStarted: 'Account Reactivation Started',
  UpgradeClicked: 'Upgrade to Paid Alert Clicked',
  KeepAccessClicked: 'Billing: Keep Access Clicked',
  PlanChangedFeedback: 'Billing: Plan Change Feedback',
} as const;

type Event = keyof typeof Events;

type EventProperties = Record<string, string | boolean | number>;

type WithCTAProperties = {
  cta_location: string;
  cta_name: string;
} & EventProperties;

type WithSubscriptionPlanProperties = {
  subscription_plan: string;
  location: string;
} & EventProperties;

type WithReactivationProperties = {
  subscription_plan: string;
  overdue_amount: number;
  location: string;
} & EventProperties;

type WithChangePlanProperties = {
  had_trial: boolean;
  old_plan: string;
  new_plan: string;
  reason: '_skipped_' | string;
} & EventProperties;

function useTrackBillingEvent() {
  const { track } = useEvent();

  function trackBillingEvent(event: 'AccountReactivationStarted', properties: WithReactivationProperties): void;
  function trackBillingEvent(event: 'UpgradeClicked', properties: WithCTAProperties): void;
  function trackBillingEvent(event: 'KeepAccessClicked', properties: WithSubscriptionPlanProperties): void;
  function trackBillingEvent(event: 'PlanChangedFeedback', properties: WithChangePlanProperties): void;
  function trackBillingEvent(event: Event, properties: EventProperties): void {
    track(Events[event], properties);
  }

  return trackBillingEvent;
}

export default useTrackBillingEvent;
